import { LayoutProps } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import CompanyLogo from 'components/CompanyLogo';

interface LogoPreviewCardProps extends LayoutProps {
  logoUrl: string;
  fileName?: string;
}

const LogoPreviewCard: FCWithChildren<LogoPreviewCardProps> = ({
  children,
  fileName,
  logoUrl,
}) => (
  <SunshineCard alignItems="center">
    <SunshineCard.Slot name="aside">
      <CompanyLogo
        border="1px solid"
        borderColor="border"
        borderRadius="radius-4"
        logoUrl={logoUrl}
        marginRight="space-8"
        overflow="hidden"
      />
    </SunshineCard.Slot>

    <SunshineCard.Content alignItems="center" flexDirection="row">
      {fileName ? (
        <Text fontWeight="weight-500" variant="primary">
          {fileName}
        </Text>
      ) : null}
    </SunshineCard.Content>

    <SunshineCard.Slot name="action">{children}</SunshineCard.Slot>
  </SunshineCard>
);

export default LogoPreviewCard;
